import api from './api';

export interface MeituanInventoryTimeSlot {
  begin: string;
  end: string;
  remainCount: number;
}

export interface MeituanInventoryConfig {
  id?: string;
  enabled: boolean;
  defaultDays: number;
  timeSlots: MeituanInventoryTimeSlot[];
  remark?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface SaveMeituanInventoryConfigRequest {
  enabled: boolean;
  defaultDays: number;
  timeSlots: MeituanInventoryTimeSlot[];
  remark?: string;
}

export const getMeituanInventoryConfig = () =>
  api.get<MeituanInventoryConfig>('/system-settings/meituan-inventory-config');

export const saveMeituanInventoryConfig = (data: SaveMeituanInventoryConfigRequest) =>
  api.put<MeituanInventoryConfig>('/system-settings/meituan-inventory-config', data);
